import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';

const Layout = () => {
  const location = useLocation();

  // Check if the current route is the login page
  const isLoginPage = location.pathname === '/login';

  // If on login page, render only the Outlet (Login component) full-screen
  if (isLoginPage) {
    return (
      <div className="min-h-screen">
        <Outlet />
      </div>
    );
  }

  // For all other routes, render the full layout with Sidebar and Header
  return (
    <div className="flex h-screen">
      <div className="w-[15vw] bg-white border-r border-gray-200">
        <Sidebar />
      </div>
      <div className="flex-1 flex flex-col">
        <Header />
        <div className="flex-1 overflow-y-auto p-6 bg-gray-100 w-[85vw]">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Layout;